import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ConsumableInfo} from "@/store/consumable/types";
import {Keys} from "@/constants/key";
import {ConsumableUtils} from "@/utils/consumable-utils";
import AtlasUtils from "@/utils/atlas-utils";
import SpriteUtils from "@/utils/sprite-utils";

export class PickConsumablePanel extends VerticalStandardPanel {

    private exitCallback: (() => unknown) | undefined;
    private onAcceptCallback: (() => unknown) | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, ci: ConsumableInfo, exitCallback: () => unknown, onAcceptCallback: () => unknown) {
        super(scene, canvas, Tr('novaja.nahodka'));

        this.exitCallback = exitCallback;
        this.onAcceptCallback = onAcceptCallback;

        let nameText = TextUtils.addTextByFamily(scene, ci.name.toUpperCase(), 0, -180,
            '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_BOLD);

        let light = SpriteUtils.addSprite(this.scene, 0, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, 0, -90, AtlasUtils.getConsumableShadeAtlas(ci.imageId), ci.imageId);

        let consEffectText = TextUtils.addTextByFamily(scene, ConsumableUtils.getEffectText(ci.consumableType, ci.effectType, ci.effectValue).toUpperCase(),
            0, icon.y + 80,'#e0e0e0', 13, 'normal', 450, Fonts.ARIAL_MT);

        let infoText = TextUtils.addTextAdvanced(scene, Tr('mozhno.ispolzovat.v.boju'), consEffectText.x, consEffectText.y + 40,
            '#716f6a', 12, 'normal', 450, 'center', 2, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, consEffectText, infoText]);

        this.addCloseButton(Tr('podobrat'), onAcceptCallback);
    }

    protected onClose(): void {
        this.exitCallback!();
    }

}
